/*
 * @Author: your name
 * @Date: 2022-03-25 14:13:07
 * @LastEditTime: 2022-04-29 09:42:46
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \ArtCMS\src\utils\CmsDetail.ts
 */

//cms详情
export class CmsDetail {
  cmsName: string;
  cmsLogo: string;
  cmsTel: string;
  cmsAddress: string;
  cmsEmail: string;
  cmsVideo: string;
  constructor(data: any = null) {
    if (null === data) {
      this.cmsName = "";
      this.cmsLogo = "";
      this.cmsTel = "";
      this.cmsAddress = "";
      this.cmsEmail = "";
      this.cmsVideo = "";
    } else {
      this.cmsName = data.cmsName;
      this.cmsLogo = data.cmsLogo;
      this.cmsTel = data.cmsTel;
      this.cmsAddress = data.cmsAdress;
      this.cmsEmail = data.cmsEmail;
      this.cmsVideo = data.cmsVideo;
    }
  }
}
//cmsmenu
export class CmsMenu {
  menuName: string;
  menuUrl: string;
  // menuAlias: string;
  // menuDescription: string;
  constructor(data: any = null) {
    if (null === data) {
      this.menuName = "";
      this.menuUrl = "";
      // this.menuAlias = "";
      // this.menuDescription = "";
    } else {
      this.menuName = data.menuName;
      this.menuUrl = data.menuUrl;
      // this.menuAlias = data.menuAlias;
      // this.menuDescription = data.menuDescription;
    }
  }
}
//新闻详情
export class NewsDetail {
  articleId: string;
  img: string;
  date: string;
  title: string;
  content: string;
  constructor(data: any = null) {
    if (null === data) {
      this.articleId = "";
      this.img = "";
      this.date = "";
      this.title = "";
      this.content = "";
    } else {
      this.articleId = data.articleId;
      this.img = data.url;
      this.date = data.date;
      this.title = data.title;
      this.content = data.content;
    }
  }
}
export class NewsModule {
  menuId: string;
  desc: string;
  title: string;
  // newsList: Array<NewsDetail>;
  constructor(data: any = null) {
    if (null === data) {
      this.menuId = "";
      this.desc = "";
      this.title = "";
      // this.newsList = [];
    } else {
      this.menuId = data.menuId;
      this.desc = data.desc;
      this.title = data.title;
      // this.newsList = data.newsList;
    }
  }
}

export class PartnerModule {
  desc: string;
  title: string;
  imgList: Array<string>;
  constructor(data: any = null) {
    if (null === data) {
      this.desc = "";
      this.title = "";
      this.imgList = [];
    } else {
      this.desc = data.desc;
      this.title = data.title;
      this.imgList = data.imgList;
    }
  }
}

//产品
export class ProductDetail {
  icon: string;
  img: string;
  desc: string;
  title: string;
  constructor(data: any = null) {
    if (null === data) {
      this.icon = "";
      this.img = "";
      this.desc = "";
      this.title = "";
    } else {
      this.icon = data.icon;
      this.img = data.url;
      this.desc = data.desc;
      this.title = data.title;
    }
  }
}

//产品
export class ProductModule {
  desc: string;
  title: string;
  // productList: Array<any>;
  constructor(data: any = null) {
    if (null === data) {
      this.desc = "";
      this.title = "";
      // this.productList = [];
    } else {
      this.desc = data.desc;
      this.title = data.title;
      // this.productList = data.productList;
    }
  }
}
